__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-06-02-1780407370-stable-dev/";